// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { AlertTokens } from './type';

const alertTokens: AlertTokens = {
  alertInfoBackgroundColor: 'Brand-1',
  alertInfoBorderColor: 'Brand-2',
  alertInfoFontColor: 'Brand-6',
  alertSuccessBackgroundColor: 'Success-1',
  alertSuccessBorderColor: 'Success-2',
  alertSuccessFontColor: 'Success-6',
  alertWarningBackgroundColor: 'Warning-1',
  alertWarningBorderColor: 'Warning-2',
  alertWarningFontColor: 'Warning-6',
  alertDangerBackgroundColor: 'Danger-1',
  alertDangerBorderColor: 'Danger-2',
  alertDangerFontColor: 'Danger-6',
  alertFontSize: '14/regular',
  alertFontColor: 'Neutral-text-5',
  alertPaddingX: 'Padding-16',
  alertPaddingY: 'Padding-8',
  alertBorderRadius: 'Radius-4',
  alertNearlyMargin: 'Margin-8',
  alertTitleFontSize: '16/regular',
  alertCloseFontColor: 'Neutral-text-4',
  alertCloseHoverColor: 'Neutral-text-5',
  alertMessageHoverColor: 'Neutral-fill-2',
};

export default alertTokens;
